/**
 * Date: 2021-03-22
 * description:
 *  @author wanyue
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import DropDown from "./DropDown";
import PropTypes from "prop-types";
import React from "react";

DropDown.propTypes = {
  extra: PropTypes.node /* 下拉组件按钮的前置元素，接收一个节点类型的数据 */,
  content: PropTypes.node /* 点击下拉组件按钮的回调，显示，*/,
  text:PropTypes.string /* 下拉组件按钮的内容  可以是string类型  也可以是节点类型 */,
  icon: PropTypes.node /* 下拉组件按钮的后置元素，接收一个节点类型的数据 */,
  unClosekeys:PropTypes.array /*array 包含的菜单的key值，如果包含选的菜单时不关闭菜单弹窗，当isClickClose存在并且为true时生效*/,
  isClickClose: PropTypes.bool /* 是否选中菜单时关闭菜单，默认为false */,
  inputParam: {
    onVisibleChange: PropTypes.func,
    visible: PropTypes.bool,
  },
};

DropDown.defaultProps = {
  text: "按钮",
  inputParam: {
    visible: false,
  },
};

export default DropDown;



// WEBPACK FOOTER //
// ./src/pages/Component/YxDropMenu/index.js